export default {
	"lanEnTxt": "English",
	"lanZhTxt": "Chinese",
	"login": 'Login',
	"register": 'Register',
	"confirmDialog": {
		"logoutTitle": "Confirm",
		"logoutMsg": "Are you sure you want to logout?",
		"confirmBtn": "Yes",
		"cancelBtn": "No",
		"logoutErr": "Logout error: "
	},
	"userTopBar": {
			"welcome": "Welcome to",
			"systemName": "  Binli Logistics System",
			"memberId": "Member ID: "
		},
		"header": {
			"nav": {
			"home": "Home",
			"logisticsQuery": "Logistics Query",
			"shopIndex": "	Shop Home",
			"freightEstimate": "Freight Estimate",
			"mainBusiness": "Main Business",
			"latestNews": "Latest News",
			"faq": "FAQ",
			"aboutUs": "About Us"
		},
		"userName": "Zhang Deshuai",
		"logout": "Logout",
		"breadcrumb": {
			"label": "Current Location:",
			"home": "Home",
			"newsPage": "Latest News",
			"backBtn": "Back"
		}
	},
	"footer": {
		"friendLinks": {
			"label": "Friend Links",
			"baidu": "Baidu",
			"fengchi": "Fengchi World",
			"douyin": "Douyin"
		},
		"cols": {
			"resource": {
				"title": "Resources",
				"latestNews": "Latest News",
				"faq": "FAQ"
			},
			"express": {
				"title": "Express",
				"prohibitedItems": "Prohibited Items Policy",
				"serviceTerms": "Service Terms & Conditions"
			},
			"solutions": {
				"title": "Solutions",
				"myOrder": "My Orders",
				"shippingTutorial": "Shipping Tutorial",
				"orderManagement": "Order Management",
				"logisticsQuery": "Logistics Tracking",
				"shopIndex": "	Shop Home",
			},
			"about": {
				"title": "About",
				"express100": "Kuaidi 100",
				"aboutUs": "About Us",
				"shentong": "Shentong Express",
				"yuantong": "YTO Express",
				"zhongtong": "ZTO Express"
			}
		},
		"contact": {
			"title": "Follow or Contact Us",
			"desc": "Follow Binli WeChat Official Account & Mini Program",
			"hotline": "Hotline",
			"btnText": "Contact Us",
			"btnText1": "Domestic Phone",
			"btnText2": "International Phone",
			"btnText3": "WeChat"
		},
		"copyright": {
			"text": "Copyright©2016-2020. All rights reserved. Yijingtong LCL Consolidation",
			"icp": "ICP No. 15111761 | Yijingtong Shipping Tech Support"
		}
	},
	"userPageLeft":{
		"txt1": "Home",
		"txt2": "Order Now",
		"txt3": "My Orders",
		"txt4": "Address",
		"txt5": "Marks",
		"txt6": "Warehouse",
		"txt7": "Profile",
		"txt8": "FAQs",
		"txt9": "Contact Us",
		"txt10": "User Agreement",
		"txt11": "Logout"
	},
	"userPageL": {
		"txt1": "Home",
		"txt2": "Order",
		"txt3": "Consolidated",
		"txt4": "Packages",
		"txt5": "Purchasing",
		"txt6": "Coupons",
		"txt7": "Favorites",
		"txt8": "Addresses",
		"txt9": "WH Address",
		"txt10": "Notifications",
		"txt11": "Profile",
		"txt12": "FAQs",
		"txt13": "Agreement",
		"txt14": "Logout"
	},
	"indexHme":{
		"txt1": "Choose Binli Tech for Logistics",
		"txt2": "Speed Service",
		"txt3": "Dual Online",
		"txt4": "Mission Ready",
		"txt5": "Super Reliable",
		"txt6": "Origin",
		"txt7": "Select",
		"txt8": "Destination",
		"txt9": "Weight",
		"txt10": "Dimensions",
		"txt11": "Search",
		"txt12": "Process",
		"txt13": "Ship to us, wait for receipt",
		"txt14": "Our Advantages",
		"txt15": "Speed, Price, Safety - Full Service",
		"txt16": "Trust Us",
		"txt17": "Smart logistics with intelligent tech for better solutions.",
		"txt18": "Logistics News",
		"txt19": "Latest industry updates",
		"txt20": "Guangzhou Beetle Digital",
		"txt21": "Yijingtong, a Beetle Digital brand",
		"txt22": "Tencent Cloud Innovation Ecosystem supports enterprise growth.",
		"txt23": "Details",
		"txt24": "Enter",
		"txt25": "Length",
		"txt26": "Width",
		"txt27": "Height",
		"txt28": "Search country/region",
		"txt29": "No results"
	},
	"indexSeach":{
		"t1": "Track cargo in real-time. Enter tracking No. for location, status, ETA. Supports web, app, mini-program. Alerts for delays/damage.",
		"t2": "Enter tracking No.",
		"t3": "Search",
		"t4": "No data",
		"t5": "Origin WH",
		"t6": "Delivery Address",
		"t7": "WH Entry No.",
		"t8": "Tracking",
		"t9": "Collapse",
		"t10": "Expand",
		"t11": "Enter tracking or WH No.",
		"t12": "Copied"
	},
	"indexFreight":{
		"t1":'Forecast shipping costs fast. Enter weight, volume, destination & method. Compare plans, save time & money.',
		"t2": "",
		"t3": "Origin",
		"t4": "Select",
		"t5": "Destination",
		"t6": "Weight",
		"t7": "Enter",
		"t8": "Dimensions",
		"t9": "Length",
		"t10": "Width",
		"t11": "Height",
		"t12": "Search",
		"t122": "No tracking info",
		"t13": "Origin WH",
		"t14": "Delivery Address",
		"t15": "Goods Weight",
		"t16": "Chargeable Weight",
		"t17": "Goods Volume",
		"t18": "Chargeable Volume",
		"t19": "Details",
		"t20": "Order Now",
		"t21": "Description",
		"t22": "Shipping Channel",
		"t23": "Select Origin",
		"t24": "Select Destination",
		"t25": "Enter Weight",
		"t26": "Enter Length",
		"t27": "Enter Width",
		"t28": "Enter Height",
		"t29": "Search country/region",
		"t30": "No results"
	},
	"indexFMsg":{
		"t1": "Choose Binli Tech for Logistics",
		"t2": "Speed Service",
		"t3": "Dual Online",
		"t4": "Mission Ready",
		"t5": "Super Reliable",
		"t6": "Delivery",
		"t7": "Dest",
		"t8": "Billing",
		"t9": "First + Extra",
		"t10": "Tiers",
		"t11": "Multi Extra",
		"t12": "Tiered Extra",
		"t13": "Vol Calc",
		"t14": "L",
		"t15": "W",
		"t16": "H",
		"t17": "Billing Std",
		"t18": "First",
		"t19": "Extra",
		"t20": "Max Wt",
		"t21": "Channel Rules",
		"t22": "None",
		"t23": "Notes",
		"t24": "Allowed",
		"t25": "Pricing"
	},
	"newsList": {
	  "t1": "No relevant information"
	},
	"newsMsg": {
	  "t1": "Article Details",
	  "t2": "Published Date",
	  "t3": "Previous",
	  "t4": "Next"
	},
	"Business": {
	  "t1": "Binli - Main Business",
	  "t2": "Hazardous Labels | Marine Compensation | Sensitive Goods"
	},
	"other": {
	  "t1": "FAQs",
	  "t2": "News"
	},
	"userCenter": {
	  "t1": "Shipping",
	  "t2": "All Orders",
	  "t3": "WH Address",
	  "t4": "More",
	  "t5": "WH Name",
	  "t6": "Postal Code",
	  "t7": "Contact",
	  "t8": "Phone",
	  "t9": "Delivery Address",
	  "t10": "Quick Links",
	  "t11": "Latest Orders",
	  "t12": "All Orders",
	  "t13": "No orders",
	  "t14": "#",
	  "t15": "WH No.",
	  "t16": "Order Date",
	  "t17": "Origin",
	  "t18": "Method",
	  "t19": "Dest",
	  "t20": "Status",
	  "t21": "Actions",
	  "t22": "Pending Inbound",
	  "t23": "Inbound",
	  "t24": "Packed",
	  "t25": "In Transit",
	  "t26": "Pending Receipt",
	  "t27": "Received",
	  "t28": "Cancelled",
	  "t29": "View",
	  "link1": "Order Now",
	  "link2": "My Orders",
	  "link3": "Marks",
	  "link4": "Tracking",
	  "link5": "Freight Estimate",
	  "link6": "WH Address",
	  "link7": "Profile",
	  "link8": "FAQs",
	  "link9": "Agreement"
	},
	"uinfo": {
	  "t1": "Profile",
	  "t2": "Avatar",
	  "t3": "Nickname",
	  "t4": "Enter nickname",
	  "t5": "Country",
	  "t6": "Select",
	  "t7": "Mobile",
	  "t8": "Enter mobile",
	  "t9": "Bind",
	  "t10": "WeChat",
	  "t11": "Enter WeChat ID",
	  "t12": "Gender",
	  "sex1": "Male",
	  "sex2": "Female",
	  "t13": "City",
	  "t14": "Enter city",
	  "t15": "Email",
	  "t16": "Enter email",
	  "t17": "Enter WhatsApp",
	  "t18": "Save",
	  "t19": "Bind Mobile",
	  "t20": "Bind Email",
	  "t21": "Verification Code",
	  "t22": "Enter code",
	  "t23": "Get Code",
	  "t24": "Back",
	  "t25": "Confirm",
	  "t26": "Search country/region",
	  "t27": "No results"
	},
	"point": {
	  "t1": "WH Address",
	  "t2": "Enter contact",
	  "t3": "Enter phone",
	  "t4": "Enter address",
	  "t5": "Search",
	  "t6": "Postal Code",
	  "t7": "Copy Address"
	},
	"marks": {
	  "t1": "Marks",
	  "t2": "No info",
	  "t3": "Default",
	  "t4": "Edit",
	  "t5": "Delete",
	  "t6": "Add Mark",
	  "t7": "Edit Mark",
	  "t8": "Mark Name",
	  "t9": "Enter mark name",
	  "t10": "Phone",
	  "t11": "Enter phone",
	  "t12": "Set as default",
	  "t13": "Yes",
	  "t14": "No",
	  "t15": "Back",
	  "t16": "Confirm",
	  "t17": "Confirm Add"
	},
	"olist": {
	  "t1": "Enter order / WH No. / Mark",
	  "t2": "Search",
	  "t3": "Order Date",
	  "t4": "Select",
	  "t5": "All Months",
	  "t6n": "#",
	  "t6": "Image",
	  "t7": "WH No.",
	  "t8": "Mark",
	  "t9": "Weight(kg)",
	  "t10": "Volume(m)",
	  "t11": "Shipping",
	  "t12": "Origin",
	  "t13": "Dest",
	  "t14": "Order Date",
	  "t15": "Status",
	  "t16": "Actions",
	  "t17": "Not Inbound",
	  "t18": "Inbound",
	  "t19": "Packed",
	  "t20": "In Transit",
	  "t21": "Pending Receipt",
	  "t22": "Received",
	  "t23": "Cancelled",
	  "t24": "Edit",
	  "t25": "Cancel",
	  "t26": "Delete",
	  "t27": "Sign",
	  "t28": "View",
	  "hb1": "Cancel Order",
	  "hb2": "Cancel Info",
	  "hb3": "Enter cancel reason",
	  "hb3n": "Upload cancel image",
	  "hb4": "Cancel Image",
	  "hb5": "Back",
	  "hb6": "Confirm Cancel",
	  "hb7": "Delete Order",
	  "hb8": "Delete this order?",
	  "hb9": "Confirm Delete",
	  "hb10": "Sign Order",
	  "hb11": "Sign Remarks",
	  "hb12": "Enter sign remarks",
	  "hb12n": "Upload sign photo",
	  "hb13": "Sign Photo",
	  "hb14": "Confirm Sign",
	  "all": "All"
	},
	"omsg": {
	  "t1": "Current Location",
	  "t2": "My Orders",
	  "t3": "Order Details",
	  "t4": "Origin WH",
	  "t5": "Delivery Address",
	  "t6": "WH No.",
	  "t7": "Basic Info",
	  "t8": "Mark",
	  "t9": "Shipping",
	  "t10": "Payer",
	  "t11": "Shipper",
	  "t12": "Consignee",
	  "t13": "Split Payment",
	  "t14": "Customs Method",
	  "t15": "Full Agency",
	  "t16": "Self Declaration",
	  "t17": "Delivery Method",
	  "t18": "Self Pickup",
	  "t19": "Delivery",
	  "t20": "Location No.",
	  "t21": "None",
	  "t22": "Shelf No.",
	  "t23": "Contact No.",
	  "t24": "Order Date",
	  "t25": "Remarks",
	  "car1": "Vehicle Export Docs",
	  "car2": "No info",
	  "car3": "Registration",
	  "car4": "View",
	  "car5": "Vehicle License",
	  "car6": "Contract",
	  "car7": "Permit",
	  "car8": "Other",
	  "car9": "Mileage Photo",
	  "car10": "Mileage",
	  "car11": "Contact",
	  "pay1": "Cost Info",
	  "pay2": "Payment Details",
	  "pay3": "Payment Status",
	  "pay4": "Pending",
	  "pay5": "Paid",
	  "pay6": "Partial",
	  "pay7": "Freight",
	  "pay8": "Value-Added",
	  "pay9": "Amount Due",
	  "pay10": "Amount Paid",
	  "pay11": "Paid",
	  "pay12": "Pending",
	  "pay13": "Actions",
	  "pay14": "View Freight",
	  "o1": "Shipping Status",
	  "o2": "Current Tracking",
	  "gys1": "Supplier Info",
	  "gys2": "Name",
	  "gys3": "Contact",
	  "g1": "Product Info",
	  "g2": "#",
	  "g3": "Image",
	  "g4": "Tracking No.",
	  "g5": "Product",
	  "g6": "Weight(kg)",
	  "g7": "Volume(m)",
	  "g8": "Value()",
	  "g9": "Qty",
	  "g10": "Packing",
	  "g11": "Pack No.",
	  "g12": "Cargo Type",
	  "g13": "Total Value()",
	  "g14": "Total Qty",
	  "ku1": "Inbound Info",
	  "ku2": "Volume",
	  "ku3": "Shelf No.",
	  "ku4": "Weight",
	  "ku5": "Inbound Time",
	  "ku6": "Inbound Images",
	  "ku7": "Inbound Videos",
	  "ku8": "Container Info",
	  "ku9": "Container No.",
	  "ku10": "Container Size",
	  "ku11": "Loading Images",
	  "ku12": "Loading Videos",
	  "btn1": "Cancel",
	  "btn2": "Delete",
	  "btn3": "Edit",
	  "btn4": "Sign"
	},
	"ofee": {
		"t1": "Location",
		"t2": "My Orders",
		"t3": "Details",
		"t4": "Freight",
		"t5": "Billing",
		"t6": "First+Extra",
		"t7": "Tiers",
		"t8": "Multi-Extra",
		"t9": "Tiered+Extra",
		"t10": "Dest",
		"t11": "Wt",
		"t12": "Vol",
		"t13": "Freight",
		"t14": "Billing Std",
		"t15": "First",
		"t16": "Extra",
		"t17": "Max Wt"
	},
	"paylist": {
		"t1": "Location",
		"t2": "My Orders",
		"t3": "Details",
		"t4": "Payment",
		"t5": "No data",
		"t6": "Image",
		"t7": "Note",
		"t8": "Account",
		"t9": "Txn No.",
		"t10": "Pay Time",
		"t11": "Amount",
		"t12": "Status",
		"t13": "Reviewing",
		"t14": "Approved",
		"t15": "Rejected",
		"t16": "Submit Payment"
	},
	"payAdd": {
		"t1": "Basic",
		"t2": "Order No.",
		"t3": "WH No.",
		"t4": "Due",
		"t5": "Paid",
		"t6": "Balance",
		"t7": "Pay Amount",
		"t8": "Enter amount",
		"t9": "Desc",
		"t10": "Enter desc",
		"t11": "Other",
		"t12": "Account",
		"t13": "Enter account",
		"t14": "Txn No.",
		"t15": "Enter txn No.",
		"t16": "Upload Screenshot",
		"t17": "Save",
		"t18": "Upload image"
	},
	"ocang": {
		"t1": "Current Location",
		"t2": "Order Now",
		"t3": "Select Warehouse",
		"t4": "Confirm"
	},
	"ogoods": {
		"t1": "Current Location:",
		"t2": "Order Now",
		"t3": "Edit Cargo",
		"t4": "Add Cargo",
		"t5": "Shipping Info",
		"t6": "Product Name",
		"t7": "Enter product name",
		"t8": "Weight(kg)",
		"t9": "Enter weight",
		"t10": "Quantity",
		"t11": "Enter quantity",
		"t12": "Dimensions(m³)",
		"t13": "Enter value",
		"t14": "Length cm",
		"t15": "Width cm",
		"t16": "Height cm",
		"t17": "Volume(m³)",
		"t18": "Enter volume",
		"t19": "PCS",
		"t20": "Enter PCS",
		"t21": "Value(rmb)",
		"t22": "Enter value",
		"t23": "Cargo Type(multi-select)",
		"t24": "Please select",
		"t25": "Condition",
		"t26": "New",
		"t27": "Used",
		"t28": "Refurbished",
		"t29": "Tracking No.",
		"t30": "Enter tracking No.",
		"t31": "Upload Photos",
		"t32": "Update",
		"t33": "Add",
		"t34": "Please enter product name",
		"t35": "Please enter quantity",
		"t36": "Please select cargo type",
		"t37": "Yes",
		"t38": "No",
	},
	"opage": {
		"t1": "Origin Warehouse",
		"t2": "Select Warehouse",
		"t3": "Consignee",
		"t4": "Position",
		"t5": "Please select",
		"t6": "Country",
		"t7": "Phone",
		"t8": "Enter contact phone",
		"t9": "Mark",
		"t10": "Please select mark",
		"t11": "Select",
		"t12": "Shipping Info",
		"t13": "Shipping Method",
		"t14": "Customs Method",
		"t15": "Delivery Method",
		"t16": "Remarks",
		"t17": "Enter remarks",
		"t18": "Payer",
		"t19": "Supplier Name",
		"t20": "Enter supplier name",
		"t21": "Supplier Phone",
		"t22": "Enter supplier mobile",
		"t23": "Services",
		"t24": "Vehicle Documents Required",
		"t25": "Is Vehicle",
		"t26": "Registration Cert",
		"t27": "Click to upload PDF or image",
		"t28": "View",
		"t29": "Contract",
		"t30": "Other",
		"t31": "Mileage Photo",
		"t32": "Vehicle License",
		"t33": "Permit",
		"t34": "Mileage",
		"t35": "Enter mileage",
		"t36": "Contact",
		"t37": "Enter vehicle supplier contact",
		"t38": "Cargo Info",
		"t39": "Add",
		"t40": "No cargo info",
		"t41": "Tracking No.",
		"t42": "Copy",
		"t43": "Edit",
		"t44": "Update",
		"t45": "Place Order",
		// Option labels
		"o1": "Full Customs Service",
		"o2": "Self Declaration",
		"o3": "Self Pickup",
		"o4": "Delivery",
		"o5": "Shipper",
		"o6": "Consignee",
		"o7": "Split Payment",
		"o8": "Yes",
		"o9": "No",
		"o10": "Please select position",
		// Error messages
		"e1": "Please select position",
		"e2": "Please enter supplier phone",
		"e3": "Please upload mileage photo",
		"e4": "Please enter vehicle supplier contact",
		"e5": "Please select country",
		"e6": "Please select mark",
		"e7": "Please add cargo info",
		"ge0": "Name",
		"ge1": "Quantity",
		"ge2": "Volume",
		"ge3": "Cargo Value",
		"ge4": "Cargo Type",
		"ge5": "Length",
		"ge6": "Width",
		"ge7": "Height",
		"ge8": "My Cart",
	}
}